import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isNil } from '@pct-ts/typeguard';

@Pipe({
  name: 'includes',
})
export class IncludesPipe implements PipeTransform {
  transform<T>(array: T[], value: T): boolean {
    return isNil(array) ? false : array.includes(value);
  }
}
